import axiosInstance from "../../utils/axiosInstance";
import {PATH_ACTION_TYPES} from "../typesAction";


export const setLoading = () => {
    return {type: PATH_ACTION_TYPES.LOAD_PATH}
};

export const clearLoading = () => {
    return {type: PATH_ACTION_TYPES.CLEAR_LOAD_PATH}
};

export const clearPathError = () => {
    return {type: PATH_ACTION_TYPES.CLEAR_PATH_ERRORS}
};

export const listPaths = (history, pagination, filters = {}, sorter) => async dispatch => {
    try {
        dispatch(setLoading());
        // Prepare all query parameters
        let queryParameters = {}
        Object.keys(filters).map(key => (
            queryParameters[key] = filters[key] == null ? filters[key] : filters[key][0])
        );
        if (sorter !== undefined) {
            queryParameters['sort'] = sorter['field']
            queryParameters['order'] = sorter['order'] === 'descend' ? 'desc' : 'asc'
        }
        if (pagination !== undefined) {
            queryParameters['offset'] = (pagination.current - 1) * pagination.pageSize
            queryParameters['max'] = pagination.pageSize
        }
        // Spread the parameters
        const params = {
            ...queryParameters
        };
        // Send request and get data
        const {data} = await axiosInstance(history, dispatch).get('/path', {params});
        // Update state
        dispatch({
            type: PATH_ACTION_TYPES.LIST_PATH,
            payload: data
        });
    } catch (err) {
        console.log(err);
        dispatch({
            type: PATH_ACTION_TYPES.ERROR_PATH,
            payload: err.message
        });
    }
};

export const addPath = (history, path, setPathCreated) => async dispatch => {
    try {
        dispatch(setLoading());
        // Send request and get data
        const {data} = await axiosInstance(history, dispatch).post('/path', path);
        // Update state
        dispatch({
            type: PATH_ACTION_TYPES.ADD_PATH,
            payload: data
        });
        setPathCreated(true);
    } catch (err) {
        console.log(err);
        const error = await err.response.data;
        dispatch({
            type: PATH_ACTION_TYPES.ERROR_PATH,
            payload: error
        });
    }
};

export const getPath = (history, id) => async dispatch => {
    try {
        dispatch(setLoading());
        // Send request
        const {data} = await axiosInstance(history, dispatch).get(`/path/${id}`);
        // Update state
        dispatch({
            type: PATH_ACTION_TYPES.SHOW_PATH,
            payload: data
        });
        return data;
    } catch (err) {
        console.log(err);
        dispatch({
            type: PATH_ACTION_TYPES.ERROR_PATH,
            payload: err.message
        });
    }
};

export const editPath = (history, id, path, setPathCreated) => async dispatch => {
    try {
        dispatch(setLoading());
        // Send request and get data
        const {data} = await axiosInstance(history, dispatch).patch(`/path/${id}`, path);
        // Update state
        dispatch({
            type: PATH_ACTION_TYPES.EDIT_PATH,
            payload: data
        });
        setPathCreated(true);
    } catch (err) {
        console.log(err);
        const error = await err.response.data;
        dispatch({
            type: PATH_ACTION_TYPES.ERROR_PATH,
            payload: error
        });
    }
};

export const deletePath = (history, id) => async dispatch => {
    try {
        dispatch(setLoading());
        // Send request
        await axiosInstance(history, dispatch).delete(`/path/${id}`);
        // Update state
        dispatch({
            type: PATH_ACTION_TYPES.DELETE_PATH,
            payload: id
        });
    } catch (err) {
        console.log(err);
        dispatch({
            type: PATH_ACTION_TYPES.ERROR_PATH,
            payload: err.message
        });
    }
};

export const activatePath = (history, id) => async dispatch => {
    try {
        dispatch(setLoading());

        // Send request to update selected field
        await axiosInstance(history, dispatch).patch(`/path/${id}`, {selected: true});
        // Send request and get data
        const {data} = await axiosInstance(history, dispatch).get('/path');
        // Update state
        dispatch({
            type: PATH_ACTION_TYPES.LIST_PATH,
            payload: data
        });
    } catch (err) {
        console.log(err);
        dispatch({
            type: PATH_ACTION_TYPES.ERROR_PATH,
            payload: err.message
        });
    }
};

